import { render } from "./AllNotifications.vue?vue&type=template&id=eb47da5c"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__